import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const FeeAPI = {
	list: async (params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Fees",
			params,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
	getById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Fees/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
	create: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Fees",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},
	update: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Fees/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},
	delete: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Fees/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
	createInstallment: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Fees/installments",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},
	updateInstallment: async (feeId, id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Fees/" + feeId + "/installments/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},
	deleteInstallment: async (feeId, id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Fees/" + feeId + "/installments/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
};
